// Minimal, project-local shim for react-intl.
//
// The repo historically imported `injectIntl` from `@/react-intl`.
// At some point the file disappeared and many TS builds started failing.

import * as ReactIntl from 'react-intl';

export const injectIntl = ReactIntl.injectIntl;
export const withIntl = ReactIntl.injectIntl;
export const IntlProvider = ReactIntl.IntlProvider;
export const useIntl = ReactIntl.useIntl;
export const defineMessages = ReactIntl.defineMessages;

